'use client';

import { useLayoutEffect } from 'react';
import { DEFAULT_APPEARANCE, DEFAULT_HUE, setAccentHue, setAppearance } from '@/lib/theme';

/**
 * Auth/public pages are permanently black-and-gold. Dashboard theming writes the
 * org hue onto <html>; reset it before auth pages paint after soft navigation.
 */
export function AuthThemeReset() {
  useLayoutEffect(() => {
    setAccentHue(DEFAULT_HUE);
    setAppearance(DEFAULT_APPEARANCE);
  }, []);

  return null;
}
